"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcomailTemplateEnum = void 0;
var EcomailTemplateEnum;
(function (EcomailTemplateEnum) {
    EcomailTemplateEnum[EcomailTemplateEnum["Activation"] = 1] = "Activation";
    EcomailTemplateEnum[EcomailTemplateEnum["Cancelled"] = 6] = "Cancelled";
    EcomailTemplateEnum[EcomailTemplateEnum["CancelledFollowup"] = 7] = "CancelledFollowup";
})(EcomailTemplateEnum = exports.EcomailTemplateEnum || (exports.EcomailTemplateEnum = {}));
//# sourceMappingURL=ecomail-template-enum.js.map